import { useContext } from "preact/hooks"
import assets, { eventDays, getDay } from "src/isf-2025/assets"
import { DayContext } from "src/isf-2025/contexts/DayContext"
import { auditoriumOneAgenda, auditoriumTwoAgenda } from "src/isf-2025/data/agendas"
import { useDateTime } from "src/utils/hooks"

export default function WhatsOnNow() {
    const context = useContext(DayContext)
    const now = useDateTime()
    const date = eventDays[getDay(context.date.day)]

    const current = context.date.day !== null ? date : now

    const auditoriumOne = auditoriumOneAgenda.find(it => {
        const [start, end] = [it.startDate, it.endDate].map(d => new Date(d))
        return current.getTime() >= start.getTime() && current.getTime() < end.getTime()
    })

    const auditoriumTwo = auditoriumTwoAgenda.find(it => {
        const [start, end] = [it.startDate, it.endDate].map(d => new Date(d))
        return current.getTime() >= start.getTime() && current.getTime() < end.getTime()
    })

    return <>
        <div style="display: flex; flex-direction: column; justify-content: space-around; width: 100%; color: white;">
            <h1 style="font-size: 28px; margin: 0;">What's On Now</h1>
            <div style={{display: "flex", gap: "20px", height: "400px", marginTop: "20px"}}>
                <WhatsOnCard>
                    <h1>Auditorium One</h1>
                    { auditoriumOne && <>
                        <div>
                            <h4>{auditoriumOne.title}</h4>
                            <h5>{auditoriumOne.speaker}</h5>
                        </div>
                        <h4>{timeLine(auditoriumOne.startDate, auditoriumOne.endDate)}</h4>
                    </> }
                    { !auditoriumOne && <>
                        <h4>Currently there&apos;s no session running</h4>
                    </> }
                </WhatsOnCard>
                <WhatsOnCard>
                    <h1>Auditorium Two</h1>
                    { auditoriumTwo && <>
                        <div>
                            <h4>{auditoriumTwo.title}</h4>
                            <h5>{auditoriumTwo.speaker}</h5>
                        </div>
                        <h4>{timeLine(auditoriumTwo.startDate, auditoriumTwo.endDate)}</h4>
                    </> }
                    { !auditoriumTwo && <>
                        <h4>Currently there&apos;s no session running</h4>
                    </> }
                </WhatsOnCard>
            </div>
        </div>
    </>
}

function timeLine(start, end) {
    const startDt = new Date(start)
    const endDt = new Date(end)

    const convert = (numb) => numb.toString().padStart(2, "0")

    return `${convert(startDt.getHours())}:${convert(startDt.getMinutes())} - ${convert(endDt.getHours())}:${convert(endDt.getMinutes())}`
}

function WhatsOnCard(props) {
    return <div style={{
        backgroundImage: `url(${assets.global.PopupBGDesign})`,
        backgroundSize: "cover",
        borderRadius: "8px",
        height: "100%",
        width: "100%",
        textAlign: "center",
        fontSize: "20px",
    }}>
        <div style={{
            padding: "1em",
            height: "calc(100% - 2em)",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
        }}>
            {props.children}
        </div>
    </div>
}